import { AbstractSecurityStorage, LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { api } from '../../common';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.authority,
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.cognitoClientId,
    scope: 'phone openid email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    // Shared localStorage requires one complete refresh/validation flow across all tabs.
    useRefreshTokenLock: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: [api],
    // logLevel: LogLevel.Debug,
  },
};

@Injectable()
export class MyStorageService implements AbstractSecurityStorage {
  // OIDC completion events are tab-local. Sharing this flag makes forceRefreshSession
  // wait for an event that another tab cannot publish here. Web Locks own cross-tab exclusion.
  private readonly renewals = new Map<string, unknown>();

  read(key: string): string | null {
    const value = localStorage.getItem(key);
    if (!value) {
      this.renewals.delete(key);
      return null;
    }
    const data: Record<string, unknown> = JSON.parse(value);
    delete data['storageSilentRenewRunning'];
    if (this.renewals.has(key)) data['storageSilentRenewRunning'] = this.renewals.get(key);
    return JSON.stringify(data);
  }

  write(key: string, value: string): void {
    const data: Record<string, unknown> = JSON.parse(value);
    if ('storageSilentRenewRunning' in data) {
      this.renewals.set(key, data['storageSilentRenewRunning']);
    } else {
      this.renewals.delete(key);
    }
    delete data['storageSilentRenewRunning'];
    localStorage.setItem(key, JSON.stringify(data));
  }

  remove(key: string): void {
    this.renewals.delete(key);
    localStorage.removeItem(key);
  }

  clear(): void {
    this.renewals.clear();
    localStorage.clear();
  }
}
